/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvU0hSNk0zL0RldmVsb3BtZW50L1BhY2tJVFdlYkd1aS9zcmMvYXBwL2F1dGhlbnRpY2F0aW9uLXdhbS9hdXRoZW50aWNhdGlvbi13YW0uY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9Vc2Vycy9TSFI2TTMvRGV2ZWxvcG1lbnQvUGFja0lUV2ViR3VpL3NyYy9hcHAvYXV0aGVudGljYXRpb24td2FtL2F1dGhlbnRpY2F0aW9uLXdhbS5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/$$_gendir/app/authentication-wam/authentication-wam.component.css.shim.ngstyle.ts